import { SofaFormControl, SofaFormControlDescriptionWithGtm, SofaFormFilter, SofaFormWithGtm } from '@sofology/sofologycomponents';

export enum ValidatorTypeDescription {
    Required,
    Min,
    Max,
    MinLength,
    MaxLength,
    Regexp
}

export type StateFuncType = {
    setState: (updateStateFunc: any) => void;
    state: () => any;
};


export const SHOULD_BE_RENDERED_FUNC_NAME = 'shouldBeRendered';

export type PropertyValueType = string | Date | number | boolean | null;

export type SofaFormControlDescriptionType = SofaFormControlDescriptionWithGtm<PropertyValueType>;

export type SofaFormType = SofaFormWithGtm<Record<string, SofaFormControl<PropertyValueType>>>;

export type DynamicControlFilterType = SofaFormFilter<string> | SofaFormFilter<string | null> | SofaFormFilter<number | null> | SofaFormFilter<Date | null> | SofaFormFilter<string | boolean>;

export type DataAccessObjectType = Record<string, () => string | number | boolean | null>;

export type IlpApplicationDataType = Record<string, string | boolean | number | null>;